module.exports = __webpack_public_path__ + "img/2025special_04.f655ad4f.jpg";